import service from '@/store/services/workshop/spare_part_transfer-service';

const state = {
  list: {},
  spare_part_transfer: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, spare_part_transfer) => {
    state.spare_part_transfer = spare_part_transfer;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};
 
const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((spare_part_transfer) => { commit('SET_RESOURCE', spare_part_transfer); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((spare_part_transfer) => { commit('SET_RESOURCE', spare_part_transfer); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((spare_part_transfer) => { commit('SET_RESOURCE', spare_part_transfer); });
  },

  update_status({commit, dispatch}, params) {
    return service.update_status(params)
      .then((spare_part_transfer) => { commit('SET_RESOURCE', spare_part_transfer); });
  },

  // partTable({commit, dispatch}, params) {
  //   return service.partTable(params)
  //     .then((spare_part_transfer) => { commit('SET_RESOURCE', spare_part_transfer); });
  // },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((spare_part_transfer) => { commit('SET_RESOURCE', spare_part_transfer); });
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  spare_part_transfer: state => state.spare_part_transfer,
  page: state => state.meta.page,
};
 
const spare_part_transfer = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default spare_part_transfer;
